import { useCallback } from 'react';
import { preloadPreferences } from '../../hooks/usePreferences';

export const useCriticalMeta = () => {
  const getCriticalMeta = useCallback(async () => {
    // Preferences are a background warm-up, not app-critical: a failure only
    // affects coach marks / saved view preferences, so it must not block or
    // error the whole app. Consumers of usePreferences handle missing data.
    preloadPreferences().catch(() => {});

    // APIs that must succeed before the app renders (none currently beyond
    // the gate queries in useQueryState).
    const criticalMetaLoaders = [];

    try {
      await Promise.all(criticalMetaLoaders.map((loader) => loader()));
      return { success: true };
    } catch (error) {
      return { success: false };
    }
  }, []);

  return { getCriticalMeta };
};
